/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { HubSpotLinkShowPathParams, HubSpotLinkShowResponse } from '../types/HubSpotLinkShow'

/**
 * GET /:organisation/hubspot
 * @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::show
 */
export async function hubSpotLinkShow(
	organisation: HubSpotLinkShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<HubSpotLinkShowResponse>> {
	return axiosInstance.get(`/${organisation}/hubspot`, config)
}
